import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ConversationHeaderActions } from '@/components/features/conversation/ConversationHeaderActions';
import { ConversationBarContent } from '@/features/conversation/list/ConversationBarContent';
import { PageLayout } from '@/features/page-layout/PageLayout';

export const Route = createFileRoute('/_protected/t/$tenantId/conversation')({
  component: ConversationRouteLayout,
});

function ConversationRouteLayout() {
  return (
    <PageLayout header className="max-h-full max-w-full overflow-x-hidden">
      <ConversationHeaderActions />
      <ConversationBarContent />
      <Outlet />
    </PageLayout>
  );
}
